import apiKindsSport from '@/api/kinds-sport'

const state = {
  isSubmitting: false,

  kindsSportItem: null,
  isLoadingItem: false,
  validationErrorsItem: null,
}

export const mutationTypes = {
  getKindsSportItemStart: '[kindsSportItem] getKindsSportItemStart',
  getKindsSportItemSuccess: '[kindsSportItem] getKindsSportItemSuccess',
  getKindsSportItemFailure: '[kindsSportItem] getKindsSportItemFailure',

  editKindsSportItemStart: '[kindsSportItem] editKindsSportItemStart',
  editKindsSportItemSuccess: '[kindsSportItem] editKindsSportItemSuccess',
  editKindsSportItemFailure: '[kindsSportItem] editKindsSportItemFailure',

  deleteKindsSportItemStart: '[kindsSportItem] deleteKindsSportItemStart',
  deleteKindsSportItemSuccess: '[kindsSportItem] deleteKindsSportItemSuccess',
  deleteKindsSportItemFailure: '[kindsSportItem] deleteKindsSportItemFailure',
}

export const actionType = {
  getKindsSportItem: '[kindsSportItem] getKindsSportItem',
  editKindsSportItem: '[kindsSportItem] editKindsSportItem',
  deleteKindsSportItem: '[kindsSportItem] deleteKindsSportItem',
}

const mutations = {
  [mutationTypes.getKindsSportItemStart](state) {
    state.isLoadingItem = true
    state.validationItemErrors = null
  },

  [mutationTypes.getKindsSportItemSuccess](state, payload) {
    state.isLoadingItem = false
    state.kindsSportItem = payload
  },

  [mutationTypes.getKindsSportItemFailure](state, payload) {
    state.isLoadingItem = false
    state.validationItemErrors = payload
  },

  [mutationTypes.editKindsSportItemStart]() {},

  [mutationTypes.editKindsSportItemSuccess]() {},

  [mutationTypes.editKindsSportItemFailure]() {},

  [mutationTypes.deleteKindsSportItemStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteKindsSportItemSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteKindsSportItemFailure](state) {
    state.isSubmitting = false
  },
}

const actions = {
  [actionType.getKindsSportItem](context, {id}) {
    context.commit(mutationTypes.getKindsSportItemStart)
    return new Promise((resolve) => {
      apiKindsSport
        .getKindsSportItem(id)
        .then((response) => {
          context.commit(mutationTypes.getKindsSportItemSuccess, response.data)
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getKindsSportItemFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionType.editKindsSportItem](context, sport) {
    context.commit(mutationTypes.editKindsSportItemStart)
    return new Promise((resolve) => {
      apiKindsSport
        .editKindsSport(sport)
        .then((response) => {
          context.commit(mutationTypes.editKindsSportItemSuccess, response.data)
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.editKindsSportItemFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionType.deleteKindsSportItem](context, {id}) {
    context.commit(mutationTypes.deleteKindsSportItemStart)
    return new Promise((resolve) => {
      apiKindsSport
        .deleteKindsSport(id)
        .then((response) => {
          context.commit(
            mutationTypes.deleteKindsSportItemSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.deleteKindsSportItemFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
